import React from "react"
import { Icon } from ".."
import { Blockquote } from "../Blockquotes"

const TrainingArticleHeader = ({ userTraining, module, moduleKnowledge }) => {
  if (!userTraining || !module || !moduleKnowledge) {
    return null
  }

  const { name } = userTraining
  const completed = Boolean(moduleKnowledge.completedAt)

  return (
    <Blockquote
      icon={<Icon name="training" />}
      title={`${name} - ${module.name}`}
      body={
        <>
          {!completed && (
            <>
              Please review the following content as part of your training. Once you understand all the content
              contained, use the confirmation button at the end of this page to progress with your training.
            </>
          )}
          {completed && <>You have already indicated you have read and understood this training content.</>}
        </>
      }
    />
  )
}

export { TrainingArticleHeader }
